import React, { ReactElement } from 'react'

import Icon, { IconName } from '../../Icon'
import { SelectRangeItem } from '..'
import { SelectRangeItemState } from '../Constants'
import { SelectItem, SelectOption, SelectOptions } from '../Types'
import { ArrayUtils } from '../../../../../NonReact/utils/ArrayUtils'

export const toCheckBox = (itemState: SelectRangeItemState): ReactElement => {
    switch (itemState) {
        case SelectRangeItemState.INCLUDED:
            return (
                <div className='state-icon item-included'>
                    <Icon iconName={IconName.CHECKBOX_CHECKED} />
                </div>
            )
        case SelectRangeItemState.EXCLUDED:
            return (
                <div className='state-icon item-excluded'>
                    <Icon iconName={IconName.CHECKBOX_MINUS} />
                </div>
            )
        case SelectRangeItemState.NONE:
        default:
            return (
                <div className='state-icon item-none'>
                    <Icon iconName={IconName.CHECKBOX_BLANK} />
                </div>
            )
    }
}

export const toItem = (item: SelectRangeItem, handleItemClick: (item: SelectRangeItem) => void): ReactElement => {
    let { state } = item
    const { value, renderElement } = item

    if (!state) {
        state = SelectRangeItemState.NONE
    }

    return (
        <div
            key={value}
            className={`item ${state === SelectRangeItemState.INCLUDED ? 'item-selected' : ''}`}
            onClick={(): void => handleItemClick(item)}
            onContextMenu={(event): void => {
                event.preventDefault()
                handleItemClick(item)
            }}
        >
            {toCheckBox(state)}
            {renderElement}
        </div>
    )
}

export const toItemFromSelectItem = (
    item: SelectItem,
    handleItemClick: (item: SelectItem) => void,
    disableCheckboxes?: boolean
): ReactElement => {
    let { state } = item
    const { value, label } = item

    if (!state) {
        state = SelectRangeItemState.NONE
    }

    return (
        <div
            key={value}
            className={`item ${state === SelectRangeItemState.INCLUDED ? 'item-selected' : ''}`}
            onClick={(): void => handleItemClick(item)}
            onContextMenu={(event): void => {
                event.preventDefault()
                handleItemClick(item)
            }}
        >
            {!disableCheckboxes && toCheckBox(state)}
            {label}
        </div>
    )
}

export const sortSelectOptionsAlphabetically = (selectOptions: SelectOptions<number>): SelectOptions<number> =>
    ArrayUtils.sortAlphabeticalByField<SelectOption<number>>(
        selectOptions,
        (telServer: SelectOption<number>): string => telServer.label
    )
